import React from 'react';
import { Tag } from "@bedrock/components";
import { localPx2rem } from '#utils';

enum Nums {
    five_Bit = '5',
    six_Bit = '6',
    seven_Bit = '7',
    eight_Bit = '8',
    nine_Bit = '9',
    ten_Bit = '10',
    eleven_Bit = '11',
    twelve_Bit = '12',
    thirteen_Bit = '13',
}

const Amount = {
    [Nums.five_Bit]: '万',
    [Nums.six_Bit]: '十万',
    [Nums.seven_Bit]: '百万',
    [Nums.eight_Bit]: '千万',
    [Nums.nine_Bit]: '亿',
    [Nums.ten_Bit]: '十亿',
    [Nums.eleven_Bit]: '百亿',
    [Nums.twelve_Bit]: '千亿',
    [Nums.thirteen_Bit]: '万亿',
};

interface Props {
    value: number | string;
    className?: string;
    style?: React.CSSProperties;
    size?: "default" | "large" | "medium" | "small" | "xSmall"
};

const AmountOrder = (props: Props) => {
    const { value, className = '', size = 'xSmall', style, ...otherProps } = props;
    let newValue;
    let length: string;
    if (typeof value === 'string') {
        newValue = Number(value.split(',').join('')) + ''
        if (isNaN(newValue)) {
            newValue = ''
        }
    } else {
        newValue = value ? Number(value) + '' : '';
    }
    newValue = newValue?.split('.')[0]
    if (newValue?.startsWith('-')) {
        // 负数需减去一位减号
        newValue = newValue.slice(1)
    }
    length = newValue?.length >= 13 ? 13 : newValue?.length;

    const renderTag = v => {
        return (
            <div className='nums-orde-container' style={{ lineHeight: localPx2rem(20), ...style }} {...otherProps}>
                <Tag
                    size={size}
                    className={`${className} nums-orde default-font fw-Normal`}
                    color='light-grey'
                    text={v}
                />
            </div>
        )
    }

    return Amount[length] ? renderTag(Amount[length]) : null;
}

export function AmountOrderWrapper(props: Props & { children: React.ReactNode }) {
    return <div
        className="sform-amount-order-wrapper"
    >
        {props.children}
        <AmountOrder {...props} />
    </div>
}


export default AmountOrder;